<template>
  <fragment>
    <v-menu
      left
      bottom
      v-model="menu"
      class="overflow-y-hidden"
      :close-on-content-click="false"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-list-item-avatar v-bind="attrs" v-on="on">
          <v-img
            :src="userInfo.avatar"
            v-if="userInfo.avatar"
            alt="userpic"
            max-height="38"
            max-width="38"
          >
          </v-img>
          <v-icon size="38" v-else>mdi-account-circle</v-icon>
        </v-list-item-avatar>
      </template>

      <v-card class="tertiary rounded-lg">
        <v-list class="tertiary">
          <v-list-item link @click="handleMyAccount">
            <v-list-item-avatar>
              <v-img
                max-height="38"
                max-width="38"
                :src="userInfo.avatar"
                v-if="userInfo.avatar"
                alt="userpic"
              ></v-img>
              <v-icon size="38" v-else>mdi-account-circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ userInfo.nome }}</v-list-item-title>
              <v-list-item-subtitle>{{ userTypeTitle }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list class="tertiary">
          <AppLanguageMenu />
          <v-list-item @click="menuOption(userType)">
            <v-list-item-title>Redefinir senha</v-list-item-title>
            <v-icon>mdi-form-textbox-password</v-icon>
          </v-list-item>
          <v-list-item @click="openModal" v-if="isStoreKeeper">
            <v-list-item-title>Termos de Uso</v-list-item-title>
            <v-icon>mdi-clipboard-edit</v-icon>
          </v-list-item>
          <v-list-item @click="menuOption('sair')">
            <v-list-item-title>Sair </v-list-item-title>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <ModalTermos :disabledButton="disabledButton" />
    <MyAccountAffiliate />
  </fragment>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import MyAccountAffiliate from "../../components/global/MyAccountAffiliate.vue";
import AppLanguageMenu from "./AppLanguageMenu.vue";
export default {
  name: "AppUserMenu",
  components: {
    ModalTermos: () => import("@/components/global/ModalTermos.vue"),
    AppLanguageMenu,
    MyAccountAffiliate,
  },
  data() {
    return {
      menu: false,
      disabledButton: false,
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "userType",
      "isAdmin",
      "isStoreKeeper",
      "isAffiliate",
      "dialogMyAccount",
    ]),
    // eslint-disable-next-line vue/return-in-computed-property
    hasProfilePicture() {
      return this.$pessoas_usuarios.user.avatar;
    },
    userType() {
      if (this.isAdmin) return "/usuario-admin-redefinir-senha";
      if (this.isAffiliate) return "/usuario-afiliado-redefinir-senha";
      return "/usuario-loja-redefinir-senha";
    },
    userTypeTitle() {
      if (this.userInfo.user_type === "admin") return "Admin";
      if (this.userInfo.user_type === "afiliado") return "Afiliado";
      return "Lojista";
    },
  },

  methods: {
    ...mapActions(["clearStateApp", "changeDialogMyAccount"]),
    openModal() {
      return this.$termos.getTermosLojista();
    },
    handleMyAccount() {
      if (this.isAffiliate) {
        this.changeDialogMyAccount();
        this.menu = false;
      }
    },
    menuOption(link) {
      if (link != "sair") {
        this.$axios.rota(link);
        return;
      }

      if (link == "sair") {
        this.$axios.removeCookie("oe_jwt");
        this.$axios.destroy(true);
        this.$axios.rota("/");
        window.localStorage.clear();
        this.clearStateApp();
        return;
      }
    },
  },
};
</script>
<style scoped>
* {
  color: #ffffff !important;
}
</style>
